import ProctorDialog from './ProctorDialog';

export default ProctorDialog;
